import * as React from 'react';
import SvenskaKyrkanLogo from '../../../../../../../Assets/Branding/Svenska_kyrkan_logo.svg';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { getServerURL } from '../../../../../../../Utils/getServerURL';
import { AnalysInitQuery_logo } from '../../Queries/EkonomiskAnalysInitQuery/_QueryTypes/AnalysInitQuery';

interface IProps {
  logo: AnalysInitQuery_logo;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      imgLogo: {
        maxWidth: '200px',
        maxHeight: '56px',
        [theme.breakpoints.down('lg')]: {
          maxWidth: '150px',
          maxHeight: '42px',
          marginRight: theme.spacing(2),
        },
      },
    } as const)
);

/**
 * En komponent som hämtar och visar rätt logga för den aktuella databasen
 */
export const EkonomiskAnalysLogo: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes, cx } = useStyles();
  const [loading, setLoading] = React.useState(true);

  return props.logo.id ? (
    <React.Fragment>
      <img
        src={`${getServerURL()}/blob?id=${props.logo.id}`}
        alt={props.logo.namn || ''}
        className={cx(classes.imgLogo)}
        onLoad={() => setLoading(false)}
      />

      {!props.logo.namnIngar && !loading && (
        <EDTypography>{props.logo.namn || ''}</EDTypography>
      )}
    </React.Fragment>
  ) : (
    <React.Fragment>
      <img
        src={SvenskaKyrkanLogo}
        alt="Svenska Kyrkan"
        className={cx(classes.imgLogo)}
        onLoad={() => setLoading(false)}
      />

      <EDTypography>{props.logo.namn || ''}</EDTypography>
    </React.Fragment>
  );
};

export default EkonomiskAnalysLogo;
